module.exports = __webpack_public_path__ + "static/img/Delete.2991ab61.png";